import React from "react";
import { useTranslation } from "react-i18next";
import StarRatings from "react-star-ratings";
import { ProgressBar } from "react-bootstrap";
import TileTitle from "./TileTitle";
import { formatNumber } from "../../helpers/templateHelpers";

function ScoreDistributionTile(props) {
  const { t, i18n } = useTranslation();

  let showHeader = props.showHeader;
  let showTitleTile = props.showTitleTile;
  let showDifference = props.showDifference;
  let reviewsStatistics = props.reviewsStatistics;


  let rate1Count = isNaN(props.rate1Count) ? 0 : props.rate1Count;
  let rate2Count = isNaN(props.rate2Count) ? 0 : props.rate2Count;
  let rate3Count = isNaN(props.rate3Count) ? 0 : props.rate3Count;
  let rate4Count = isNaN(props.rate4Count) ? 0 : props.rate4Count;
  let rate5Count = isNaN(props.rate5Count) ? 0 : props.rate5Count;

  if (props.ratings) {
    props.ratings.forEach(rating => rating.count = parseInt(rating.count));

    const totalScore = props.ratings.reduce((acc, rating) => acc + (rating.score * rating.count), 0);
    const totalCount = props.ratings.reduce((acc, rating) => acc + rating.count, 0);

    const averageRating = totalCount === 0 ? 0 : totalScore / totalCount;
    const sortedRatings = props.ratings.sort((a, b) => a.score - b.score);

    reviewsStatistics.avgRating = averageRating;
    reviewsStatistics.count = totalCount;

    rate1Count = sortedRatings[0].count;
    rate2Count = sortedRatings[1].count;
    rate3Count = sortedRatings[2].count;
    rate4Count = sortedRatings[3].count;
    rate5Count = sortedRatings[4].count;
  }
  const starColor = "#f8bf2a";
  const numStars = 5;

  const sumAllCounts =
    rate1Count + rate2Count + rate3Count + rate4Count + rate5Count;



  const determineClassName = (difference) => {
    if (!difference && difference !== 0) return "diff none";
    return Number(difference) > 0
      ? "diff positive"
      : Number(difference) < 0
        ? "diff negative"
        : "diff zero";
  };

  return (
    <div className="tile tileWhite tileScore clearfix">
      {showTitleTile && (
        <div>
          <TileTitle title={t("admin.common.rateDist")} />

          <div className="tileContent statsGeneral">
            <div className="stats statsGeneral-text">
              <p className="rate text-center">
                <strong>
                  {formatNumber( reviewsStatistics.avgRating, 1)}
                  <sup>/5</sup>
                </strong>
              </p>
              <div className="stars rate starsDashboardGeneral">
                <StarRatings
                  rating={reviewsStatistics.avgRating}
                  starRatedColor={starColor}
                  name="rating"
                  numberOfStars={numStars}
                  starDimension={"32"}
                  starSpacing={"1"}
                />
              </div>
              {showDifference ? (
                <div>
                  {!!reviewsStatistics.avgAbsoluteDifference ||
                    reviewsStatistics.avgAbsoluteDifference === 0 ? (
                    <p
                      className={determineClassName(
                        reviewsStatistics.avgAbsoluteDifference
                      )}
                    >
                      {reviewsStatistics.avgAbsoluteDifference > 0 && "+"}
                      {formatNumber(reviewsStatistics.avgAbsoluteDifference, 1)}
                    </p>
                  ) : (
                    <p className="diff none"></p>
                  )}
                </div>
              ) : (
                <p className="rateCount text-center">
                  <span>{ reviewsStatistics.count}</span>{" "}
                  {t("admin.common.review", {
                    count:  reviewsStatistics.count,
                  })}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="reviewsScoreDistributionWrap">
        {showHeader && <h3>{t("admin.common.chkBuy")}</h3>}
        <div className="reviewsScoreDistribution">
          <div className="item clearfix">
            <div className="stars rate starsScoreDestribution">
              <StarRatings
                rating={5}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <ProgressBar
              now={sumAllCounts === 0 ? 0 : (rate5Count / sumAllCounts) * 100}
              variant="success"
            />
            <span className="count fs10">{rate5Count}</span>
          </div>
          <div className="item clearfix">
            <div className="stars rate starsScoreDestribution">
              <StarRatings
                rating={4}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <ProgressBar
              now={sumAllCounts === 0 ? 0 : (rate4Count / sumAllCounts) * 100}
              variant="success"
            />
            <span className="count">{rate4Count}</span>
          </div>
          <div className="item clearfix">
            <div className="stars rate starsScoreDestribution">
              <StarRatings
                rating={3}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <ProgressBar now={sumAllCounts === 0 ? 0 : (rate3Count / sumAllCounts) * 100}
              variant="warning"
            />
            <span className="count">{rate3Count}</span>
          </div>
          <div className="item clearfix">
            <div className="stars rate starsScoreDestribution">
              <StarRatings
                rating={2}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <ProgressBar
              now={sumAllCounts === 0 ? 0 : (rate2Count / sumAllCounts) * 100}
              variant="danger"
            />
            <span className="count">{rate2Count}</span>
          </div>
          <div className="item clearfix">
            <div className="stars rate starsScoreDestribution">
              <StarRatings
                rating={1}
                starRatedColor={starColor}
                name="rating"
                numberOfStars={numStars}
                starDimension={"16"}
                starSpacing={"1"}
              />
            </div>
            <ProgressBar
              now={sumAllCounts === 0 ? 0 : (rate1Count / sumAllCounts) * 100}
              variant="danger"
            />
            <span className="count">{rate1Count}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoreDistributionTile;
